// src/data/newsData.js

export const newsData = [
    {
        title: "Akhil Lad Featured on Substack: 'This Is What It Means to Truly Listen'",
        subtitle: "An emotional and profound account shared by Dr. Ajay",
        description: "In a heartfelt Substack article, Dr. Ajay reflects on his transformative encounter with Akhil Lad. Through typed words, Akhil challenges the very nature of communication, urging us to rethink what it means to truly listen and connect with non-speaking individuals.",
        category: "Press",
        date: "2024-05-06",
        paperLink: "https://substack.com/inbox/post/161922082?r=3izcpe&utm_campaign=post&utm_medium=web",
        videoLink: "https://youtu.be/_aO-qpjcKBs",
        featured: true,
        thumbnail: "https://img.youtube.com/vi/_aO-qpjcKBs/hqdefault.jpg"
    },
    {
        title: "Akhil's Journey to College as a Non-Speaking Neurodiverse Student",
        subtitle: "Featured Speaker at World Autism Conference",
        description: "Akhil Lad shared his inspiring journey at the World Autism Conference, detailing his experiences and challenges as a non-speaking neurodiverse student pursuing higher education.",
        category: "Conference",
        date: "2024-04-09",
        paperLink: "https://worldautismconference.org/speakers-blog/akhil-lad",
        videoLink: "",
        featured: false,
        thumbnail: "/images/autism-association.png"
    },
    {
        title: "Believe: The Akhil Lad Story",
        subtitle: "Entry for CADRRE International Filmlet Festival on Autism 2024",
        description: "A short film titled 'Believe' showcasing Akhil's life and achievements was submitted to the CADRRE International Filmlet Festival on Autism 2024.",
        category: "Media",
        date: "2024-03-15",
        paperLink: "",
        videoLink: "https://www.youtube.com/watch?v=Ek__cmMdccE",
        featured: true,
        thumbnail: "https://img.youtube.com/vi/Ek__cmMdccE/hqdefault.jpg"
    },
    {
        title: "Interview with Manisha Lad on The Ripple Effect Podcast",
        subtitle: "Insights into Akhil's Autism Journey",
        description: "Manisha Lad, Akhil's mother, shared their family's journey and insights navigating autism on The Ripple Effect podcast.",
        category: "Podcast",
        date: "2025-01-26",
        paperLink: "",
        videoLink: "https://podcasts.apple.com/us/podcast/akhils-mom-manisha-lad-vulnerably-shares-their-journey/id1678006335?i=1000685521270",
        featured: false,
        thumbnail: "/images/ripple.webp"
    },
    {
        title: "Global Virtual Neurodiverse Symposium 2023",
        subtitle: "A Platform for Experts in Neurodiversity",
        description: "The Virtual Global Neurodiverse Symposium 2023 provided a platform for experts to share insights in various fields related to neurodiversity.",
        category: "Conference",
        date: "2023-07-15",
        paperLink: "https://akhilautismnds23.vfairs.com/",
        videoLink: "",
        featured: false,
        thumbnail: "/images/neurodiverse-symposium.png"
    },



];